import { createFileRoute, Link, Navigate } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth";

export const Route = createFileRoute("/racun")({
  head: () => ({
    meta: [
      { title: "Moj račun — kupish.si" },
      { name: "robots", content: "noindex,nofollow" },
    ],
      links: [{ rel: "canonical", href: "https://kupish.si/racun" }],
  }),
  component: Page,
});

function Page() {
  const { user, ready } = useAuth();

  if (!ready) {
    return (
      <section className="mx-auto max-w-2xl px-6 py-24 text-center text-muted-foreground">
        Nalagam…
      </section>
    );
  }

  if (user) return <Navigate to="/dashboard" replace />;

  return (
    <section className="mx-auto max-w-2xl px-6 py-24 text-center">
      <div className="eyebrow">Moj račun</div>
      <h1 className="font-serif text-5xl mt-3">Vaš račun</h1>
      <p className="mt-6 text-muted-foreground">
        Za dostop do vašega računa se prosim prijavite.
      </p>
      <div className="mt-8 flex gap-4 justify-center">
        <Link to="/prijava" className="px-6 py-3 bg-accent text-accent-foreground rounded">Prijava</Link>
        <Link to="/registracija" className="px-6 py-3 border border-border rounded">Registracija</Link>
      </div>
    </section>
  );
}
